import styled from "styled-components";

import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";

export const StyledCardContainer = styled(CardContainer)`
    border: none;
    margin: -16px 16px 0;
`;
